import {
  ALCOHOL_PROFILE_NO_OPTIONS,
  ALCOHOL_PROFILE_SOMETIMES_OPTIONS,
  ALCOHOL_PROFILE_YES_OPTIONS,
  CANNABIS_PROFILE_NO_OPTIONS,
  CANNABIS_PROFILE_SOMETIMES_OPTIONS,
  CANNABIS_PROFILE_YES_OPTIONS,
  CAREER_GOALS_OPTIONS,
  DIET_OPTIONS,
  DRUGS_PROFILE_NO_OPTIONS,
  DRUGS_PROFILE_SOMETIMES_OPTIONS,
  DRUGS_PROFILE_YES_OPTIONS,
  EDUCATION_OPTIONS,
  ETHNICITY_OPTIONS,
  FITNESS_ACTIVITIES_OPTIONS,
  FITNESS_FREQUENCY_OPTIONS,
  HAVE_CHILDREN_OPTIONS,
  HEIGHT_OPTIONS,
  INTENTION_OPTIONS,
  POLITICS_OPTIONS,
  RELATIONSHIP_MODEL_OPTIONS,
  RELIGION_OPTIONS,
  SMOKING_PROFILE_NO_OPTIONS,
  SMOKING_PROFILE_SOMETIMES_OPTIONS,
  SMOKING_PROFILE_YES_OPTIONS,
  STAR_SIGN_OPTIONS,
  WANT_FAMILY_OPTIONS,
  YES_OPTIONS,
} from 'constants/profile'
import { USER } from 'helpers/constants'

export const PROFILE_FIELDS = [
  {
    key: 'height',
    label: 'How Tall Are You?',
    type: 'select',
    options: HEIGHT_OPTIONS,
    required: true,
  },
  {
    key: 'religion',
    label: 'What are your religious beliefs?',
    type: 'select',
    options: RELIGION_OPTIONS,
    required: true,
  },
  {
    key: 'starSign',
    label: "What's your star sign?",
    type: 'select',
    options: STAR_SIGN_OPTIONS,
    required: true,
  },
  {
    key: 'ethnicity',
    label: 'Ethnicity',
    type: 'select',
    options: ETHNICITY_OPTIONS,
    required: true,
  },
  {
    key: 'educationLevel',
    label: 'Education Level',
    type: 'select',
    options: EDUCATION_OPTIONS,
    required: true,
  },
  {
    key: 'pronoun',
    label: 'What are your pronouns?',
    type: 'text',
  },
  {
    key: 'haveChildren',
    label: 'Do you have children?',
    type: 'select',
    options: HAVE_CHILDREN_OPTIONS,
    required: true,
  },
  {
    key: 'wantFamily',
    label: 'Do want to start a family?',
    type: 'select',
    options: WANT_FAMILY_OPTIONS,
    required: true,
  },
  {
    key: 'diet',
    label: 'How would you describe your diet?',
    type: 'select',
    options: DIET_OPTIONS,
    required: true,
  },
  {
    key: 'fitnessFrequency',
    label: 'How often do you exercise?',
    type: 'select',
    options: FITNESS_FREQUENCY_OPTIONS,
    required: true,
    nullValues: ['Never'],
  },
  {
    key: 'fitnessActivities',
    label: 'Preferred Exercises',
    type: 'multi-select',
    options: FITNESS_ACTIVITIES_OPTIONS,
    required: true,
    dependsOn: {
      key: 'fitnessFrequency',
    },
  },
  {
    key: 'careerGoals',
    label: 'Which best describes your career goals?',
    type: 'select',
    options: CAREER_GOALS_OPTIONS,
    required: true,
  },
  {
    key: 'careerGoalsDetails',
    label: 'Which best describes your career goals?',
    type: 'text',
    required: true,
  },
  {
    key: 'politics',
    label: 'What are your political values?',
    type: 'select',
    options: POLITICS_OPTIONS,
    required: true,
  },
  {
    key: 'relationshipModel',
    label: 'What is your desired relationship?',
    type: 'select',
    options: RELATIONSHIP_MODEL_OPTIONS,
    required: true,
  },
  {
    key: 'intention',
    label: 'What are you currently looking for?',
    type: 'select',
    options: INTENTION_OPTIONS,
    required: true,
  },
  {
    key: 'alcohol',
    label: 'Do you drink alcohol?',
    type: 'select',
    options: YES_OPTIONS,
    required: true,
  },
  {
    key: 'alcoholDetails',
    label: 'Alcohol',
    type: 'select',
    options: [],
    required: true,
    dependsOn: {
      key: 'alcohol',
      options: {
        yes: ALCOHOL_PROFILE_YES_OPTIONS,
        sometimes: ALCOHOL_PROFILE_SOMETIMES_OPTIONS,
        no: ALCOHOL_PROFILE_NO_OPTIONS,
      },
    },
  },
  {
    key: 'drugs',
    label: 'Do you use drugs?',
    type: 'select',
    options: YES_OPTIONS,
    required: true,
  },
  {
    key: 'drugsDetails',
    label: 'Drugs',
    type: 'select',
    options: [],
    required: true,
    dependsOn: {
      key: 'drugs',
      options: {
        yes: DRUGS_PROFILE_YES_OPTIONS,
        sometimes: DRUGS_PROFILE_SOMETIMES_OPTIONS,
        no: DRUGS_PROFILE_NO_OPTIONS,
      },
    },
  },
  {
    key: 'cannabis',
    label: 'Do you use cannabis?',
    type: 'select',
    options: YES_OPTIONS,
    required: true,
  },
  {
    key: 'cannabisDetails',
    label: 'Cannabis',
    type: 'select',
    options: [],
    required: true,
    dependsOn: {
      key: 'cannabis',
      options: {
        yes: CANNABIS_PROFILE_YES_OPTIONS,
        sometimes: CANNABIS_PROFILE_SOMETIMES_OPTIONS,
        no: CANNABIS_PROFILE_NO_OPTIONS,
      },
    },
  },
  {
    key: 'smoking',
    label: 'Do you use tobacco?',
    type: 'select',
    options: YES_OPTIONS,
    required: true,
  },
  {
    key: 'smokingDetails',
    label: 'Tobacco',
    type: 'select',
    options: [],
    required: true,
    dependsOn: {
      key: 'smoking',
      options: {
        yes: SMOKING_PROFILE_YES_OPTIONS,
        sometimes: SMOKING_PROFILE_SOMETIMES_OPTIONS,
        no: SMOKING_PROFILE_NO_OPTIONS,
      },
    },
  },
]

export const PREFERENCES_FIELDS = [
  {
    key: 'age',
    label: 'Age',
    type: 'range',
    minField: 'minAge',
    maxField: 'maxAge',
    start: USER.DESIRED_AGE_RANGE.min,
    end: USER.DESIRED_AGE_RANGE.max,
    required: true,
  },
  {
    key: 'height',
    label: 'Height',
    type: 'range',
    minField: 'minHeight',
    maxField: 'maxHeight',
    start: 0,
    end: HEIGHT_OPTIONS.length - 1,
    transformer: value => HEIGHT_OPTIONS[value]?.value,
    normalizer: value => {
      const index = HEIGHT_OPTIONS.findIndex(option => option.value === value)
      return index === -1 ? undefined : index
    },
    required: true,
  },
  {
    key: 'religion',
    label: 'Religion',
    type: 'multi-select',
    options: RELIGION_OPTIONS,
  },
  {
    key: 'ethnicity',
    label: 'Ethnicity',
    type: 'multi-select',
    options: ETHNICITY_OPTIONS,
  },
  {
    key: 'educationLevel',
    label: 'Education Level',
    type: 'multi-select',
    options: EDUCATION_OPTIONS,
  },
  {
    key: 'haveChildren',
    label: 'Are you open to matches who have children?',
    type: 'multi-select',
    options: HAVE_CHILDREN_OPTIONS,
  },
  {
    key: 'diets',
    label: 'Diet',
    type: 'multi-select',
    options: DIET_OPTIONS,
  },
  {
    key: 'fitnessFrequency',
    label: 'how often do they work out?',
    type: 'select',
    options: FITNESS_FREQUENCY_OPTIONS,
    nullValues: ['Never'],
  },
  {
    key: 'fitnessActivities',
    label: 'physical activity',
    type: 'multi-select',
    options: FITNESS_ACTIVITIES_OPTIONS,
    dependsOn: {
      key: 'fitnessFrequency',
    },
  },
  {
    key: 'careerGoals',
    label: 'Career Goals',
    type: 'select',
    options: CAREER_GOALS_OPTIONS,
  },
  {
    key: 'politics',
    label: 'Political Values',
    type: 'multi-select',
    options: POLITICS_OPTIONS,
  },
]

export const USER_DATA_KEYS = {
  PROFILE: 'profile',
  PREFERENCES: 'preferences',
}
export const USER_DATA_FIELDS = {
  [USER_DATA_KEYS.PROFILE]: PROFILE_FIELDS,
  [USER_DATA_KEYS.PREFERENCES]: PREFERENCES_FIELDS,
}
